<template>
  <div class="page-header">
    <h1>{{ simulation.name }}</h1>
    <div class="header-actions">
      <button @click="$emit('refresh')" :disabled="isRefreshing" class="btn btn-secondary">
        {{ isRefreshing ? t('simulation.header.refreshing') : t('simulation.header.refresh') }}
      </button>
      <router-link to="/simulation/history" class="btn btn-outline">{{ t('simulation.header.backToHistory') }}</router-link>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

defineProps({
  simulation: {
    type: Object,
    required: true
  },
  isRefreshing: {
    type: Boolean,
    default: false
  }
});

defineEmits(['refresh']);

const { t } = useI18n()
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
}

.page-header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #262626;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.btn {
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  text-decoration: none;
  display: inline-block;
}

.btn-secondary {
  background: #f5f5f5;
  border-color: #d9d9d9;
  color: #595959;
}

.btn-secondary:hover {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #1890ff;
}

.btn-outline {
  background: transparent;
  border-color: #d9d9d9;
  color: #595959;
}

.btn-outline:hover {
  border-color: #1890ff;
  color: #1890ff;
}
</style>
